import styled from "@emotion/styled";

export const ContainerSlideSC = styled.div`
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 48px;

  border-radius: 15px;
  background-color: #ffffff;
  border-color: transparent;
  position: relative;
`;

export const ImageContainerSC = styled.div`
  width: 100%;
  max-width: 300px;
  height: 330px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
  }
`;
